interface LoaderProps {
  loader?: boolean;
  className?: string;
  dimentions?: string;
  label?: string | null;
}

const Loader = ({ loader, className, dimentions = 'w-5 h-5', label = null }: LoaderProps) => {
  return (
    <>
      {loader && (<div className={`flex items-center ${className}`}>
        <img className={dimentions} src="/loading.gif" alt="Loading" />
        {label}
      </div>)}
    </>
  );
};

export default Loader;
